import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/admin/AQcConfig/index",{
        params:{
            ...params
        }
    })
}
function ADD_DATA(params) {
    return axios.get("/admin/AQcConfig/add", {
        params: {
            ...params
        }
    })
}
function EDIT_DATA(params) {
    return axios.get("/admin/AQcConfig/edit", {
        params: {
            ...params
        }
    })
}
function SUBMIT_ADD(params) {
    return axios.post("/admin/AQcConfig/addPost", {...params})
}
function SUBMIT_EDIT(params) {
    return axios.post("/admin/AQcConfig/editPost", {...params})
}
function DELE(params) {
    return axios.post("/admin/AQcConfig/delete", {...params})
}
function GET_DETAILS(params) {
    return axios.get("/admin/AQcConfig/detail",{
        params:{
            ...params
        }
    } )
}
function GET_NEWS_CATEGORY(params) {
    return  axios.get("/admin/AQcConfig/getNewsCategory",{
        params: {
            ...params
        }
    }  )
}

function GET_LINK2(params) {
    return axios.get("/admin/AQcConfig/getQc2Link",{
        params:{
            ...params
        }

    } )
}
function GET_LINK3(params) {
    return axios.get("/admin/AQcConfig/getQc3Link",{
        params:{
            ...params
        }

    } )
}

export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    GET_NEWS_CATEGORY,
    DELE,
    GET_DETAILS,
    GET_LINK2,
    GET_LINK3
};
